import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { Button } from '@/components/ui/button';
import FileIcon from '@/svg-icons/Files';
import { cn } from '@/lib/utils';
import { useContracts } from '@/hooks/useContracts';

const AcceptedTermsModal = ({ contracts }) => {
  const intl = useIntl();
  const [checked, setChecked] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(true);

  useEffect(() => {
    setAcceptedTerms(contracts?.pending.length === 0);
  }, [contracts]);

  const { acceptContracts } = useContracts();

  const handleIsChecked = () => {
    setChecked(!checked);
  };

  const handleAcceptTerms = () => {

    acceptContracts.mutate(
      { pendingContracts: contracts?.pending },
      {
        onSuccess: () => {
          setAcceptedTerms(true);
        },
      }
    );
  };

  if (acceptedTerms) {
    return null;
  }


  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-gray-500/70 p-4">
      <div className="flex max-w-[700px] flex-col bg-white px-10 py-[30px] md:px-[60px]">
        <p className="text-xl font-bold text-[#2B2B2B]">
          {contracts?.pending.length > 1
            ? intl.formatMessage({ id: 'REGISTRATION_READ_CONTRACTS_MESSAGE' })
            : intl.formatMessage({ id: 'REGISTRATION_READ_CONTRACT_MESSAGE' })}:
        </p>
        
        <div className="my-[30px] flex flex-col gap-[15px]">
          {contracts?.pending.map((contract) => (
            <div key={contract.url} className="flex items-center">
              <FileIcon 
                viewBox="0 0 26 26" 
                className="mr-[5px] size-[1.2em] align-bottom" 
              />
              <a 
                href={contract.url} 
                target="_blank" 
                rel="noopener noreferrer"
                className="underline hover:text-[#5882C1] transition-colors"
              >
                {contract.name}
              </a>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center -ml-[15px]">
            <input 
              id="terms" 
              type="checkbox" 
              checked={checked} 
              onChange={handleIsChecked}
              className="accent-[#5882C1] cursor-pointer"
            />
            <label 
              htmlFor="terms" 
              className="ml-2 cursor-pointer select-none"
            >
              {intl.formatMessage({ id: 'ACCEPT_CONTRACT_MESSAGE' })}
            </label>
          </div>
          
          <Button 
            disabled={!checked} 
            onClick={handleAcceptTerms}
            className={cn(
              "w-[150px] mt-2 font-bold px-2 py-[8px] rounded-[5px] transition-all normal-case border-none",
              checked 
                ? "bg-[#2B2B2B] text-white hover:bg-[#202F4A]" 
                : "bg-[#adadad] text-white cursor-not-allowed"
            )}
          >
            {intl.formatMessage({ id: 'CONFIRM' })}
          </Button>
        </div>
      </div>
    </div>
  );
};

AcceptedTermsModal.propTypes = {
  contracts: PropTypes.object.isRequired,
};

export default AcceptedTermsModal;
